module.exports = __webpack_public_path__ + "img/appstore-download-light.cacb02f5.svg";